import React from "react";
import TableIcon from "@material-ui/icons/Apps";
import { Typography } from "@material-ui/core";


function EmptyData({ flag }) {
  const nodata = {
    display: "flex",
    justifyContent: "center",
    padding:"20px 10px 20px",
    fontSize: 24,
    lineHeight: "16px",
    color: "GrayText",
    "& svg": {
      position: "relative",
      top: -2,
      width: 26,
      height: 26,
      margin: "0 6px",
      fill: "GrayText",
    },
  };
 
  return (
    <div style={nodata}>
      <TableIcon />
      <Typography>NO DATA</Typography>
    </div>
  );
}

export default EmptyData;
